import { render, staticRenderFns } from "./BeCuponComprar.vue?vue&type=template&id=3281fe17&"
import script from "./BeCuponComprar.vue?vue&type=script&lang=js&"
export * from "./BeCuponComprar.vue?vue&type=script&lang=js&"
import style0 from "./BeCuponComprar.vue?vue&type=style&index=0&id=3281fe17&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports